/* eslint-disable @typescript-eslint/naming-convention */
import { tenantConfigToString } from '@Util/string';
import React from 'react';

import { LoanBanner } from '../..';
import { BannerNotificationsProps } from '../../../index';
import { FullBannerProps } from '../../../types';
import { useByString } from '../../../utils/virtualCardUseByString';

const { splitPayVCardNotUsed } = AvantConfig.TenantConfig.accountManagementDash.bannerMessages;

export const NotUsedSplitPayVCBanner: React.FC<BannerNotificationsProps> = ({ variant, bannerProps }) => {
  const { servicingAccount: { virtual_card } } = bannerProps as FullBannerProps
  if (!virtual_card) { return null }
  const useBy = useByString(virtual_card.use_by);

  return (
    <LoanBanner variant={variant}>
      <span>
        {tenantConfigToString(splitPayVCardNotUsed, [useBy])}
      </span>
    </LoanBanner>
  );
};
